import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class SeasonDeleted extends DomainEvent<DeletedEntity> {}
